module.exports = __webpack_public_path__ + "img/user.a31a5bd9.svg";